'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.years;


// WEBPACK FOOTER //
// ./~/sugar-date/number/years.js